import { api } from '@/config/api';

export interface TranscribeResult {
  text: string;
  durationSec?: number;
}

export interface TtsUploadResult {
  url: string;
  fileId: string;
  name: string;
  durationSec?: number;
}

export const voiceService = {
  /**
   * Upload an audio file to the backend and transcribe it via Whisper.
   * Returns the transcript text and optionally the duration in seconds.
   */
  transcribe: async (file: File, language?: string): Promise<TranscribeResult> => {
    const fd = new FormData();
    fd.append('file', file);
    if (language) fd.append('language', language);
    const res = await api.post<TranscribeResult>('/slighter_crm/voice/transcribe', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60_000,
    });
    return res.data;
  },

  /**
   * Synthesize text to speech, upload to ImageKit, and return a CDN URL.
   * Use this when you want to embed the audio in a WhatsApp message.
   */
  ttsToUrl: async (
    text: string,
    voice: 'female' | 'male' | 'auto' = 'auto',
    provider?: 'openai' | 'elevenlabs',
  ): Promise<TtsUploadResult> => {
    const res = await api.post<TtsUploadResult>('/slighter_crm/voice/tts', {
      text,
      voice,
      provider,
      upload: true,
    });
    return res.data;
  },

  /**
   * Synthesize text to speech and return the audio as a Blob for immediate playback.
   * Does NOT upload to ImageKit.
   */
  ttsToBlob: async (
    text: string,
    voice: 'female' | 'male' | 'auto' = 'auto',
  ): Promise<Blob> => {
    const res = await api.post('/slighter_crm/voice/tts', { text, voice }, {
      responseType: 'blob',
    });
    return res.data as Blob;
  },
};
